import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { appAllGetHelpDesk } from '../../store/helpdesk'
import { useDispatch } from 'react-redux'
import { helpDeskExportColumns } from '../../config/exportColumns/helpDeskExportColumns'
import { useState } from 'react'

function HelpDesk() {
	const dispatch = useDispatch()
	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')
	const [exportFilters, setExportFilters] = useState({})
	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Help Desk</div>
					<div>
						<ExportButton
							fetchAction={params =>
								dispatch(
									appAllGetHelpDesk({
										...params,
										...exportFilters,
										sanstha: sansthaId || permissionOfSanstha,
										page: 1,
										limit: 100000,
										loading: false,
									}),
								)
							}
							columns={helpDeskExportColumns}
							fileName="Help_Desk"
							sheetName="Help Desk"
							buttonText="Export Help Desk"
						/>
					</div>
				</div>
				<TableFilter />
			</div>
		</>
	)
}

export default HelpDesk
